var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"container"}},[_c('Header',{attrs:{"name":_vm.layout[0].name}}),_c('Home',{attrs:{"layout":_vm.layout,"lotto":_vm.lotto}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }